import React from "react";
import ReactCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CalendarProps, CalendarTileArgs } from "../../../types";
import chevronLeftIcon from "../../../assets/icons/chevron-left.svg";
import chevronRightIcon from "../../../assets/icons/chevron-right.svg";
import doubleChevronLeftIcon from "../../../assets/icons/chevron-double-left.svg";
import doubleChevronRightIcon from "../../../assets/icons/chevron-double-right.svg";
import "./Calendar.css";

const ChevronLeft: React.FC = () => (
  <img src={chevronLeftIcon} alt="Previous" width="16" height="16" />
);

const ChevronRight: React.FC = () => (
  <img src={chevronRightIcon} alt="Next" width="16" height="16" />
);

const DoubleChevronLeft: React.FC = () => (
  <img src={doubleChevronLeftIcon} alt="Previous Year" width="16" height="16" />
);

const DoubleChevronRight: React.FC = () => (
  <img src={doubleChevronRightIcon} alt="Next Year" width="16" height="16" />
);

const Calendar: React.FC<CalendarProps> = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabledDates = [],
  tileDisabled,
  selectRange = false,
  className = "",
  style,
  showNavigation = true,
  view,
  onViewChange,
  tileContent,
  ...props
}) => {
  // Combine custom tileDisabled logic with disabledDates array prop
  const handleTileDisabled = (args: CalendarTileArgs): boolean => {
    const { date, view: currentView } = args;

    if (typeof tileDisabled === "function" && tileDisabled(args)) {
      return true;
    }

    if (currentView === "month" && Array.isArray(disabledDates) && disabledDates.length > 0) {
      return disabledDates.some((disabledDate) => {
        const d = new Date(disabledDate);
        return (
          d.getFullYear() === date.getFullYear() &&
          d.getMonth() === date.getMonth() &&
          d.getDate() === date.getDate()
        );
      });
    }

    return false;
  };

  return (
    <div className={`custom-calendar-container ${className}`} style={style}>
      <ReactCalendar
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        tileDisabled={handleTileDisabled}
        selectRange={selectRange}
        showNavigation={showNavigation}
        prevLabel={<ChevronLeft />}
        nextLabel={<ChevronRight />}
        prev2Label={<DoubleChevronLeft />}
        next2Label={<DoubleChevronRight />}
        view={view}
        onViewChange={onViewChange}
        tileContent={tileContent}
        {...props}
      />
    </div>
  );
};

export default Calendar;
